import { render, staticRenderFns } from "./LoadingTable.vue?vue&type=template&id=59a25c94&functional=true&"
import script from "./LoadingTable.vue?vue&type=script&lang=js&"
export * from "./LoadingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports